module.exports = __webpack_public_path__ + "img/1460418321.ddae5269.jpg";